<template>
    <div v-if="loading" class="flex justify-center">
        <spinner />
    </div>
    <ProductGroup v-else />
</template>

<script>
import ProductGroup from './ProductGroup.vue';
import spinner from '../../components/spinner.vue';

export default {
    components: {
        ProductGroup,
        spinner
    },
    data() {
        return {
            loading: false
        };
    },
    async created() {
        if (!this.$store.state.previewCmpy) {
            this.loading = true;
            const result = await this.$store.dispatch(
                'getPreviewProducts',
                this.$route.params.cmpyToken
            );
            if (!result || !result.company || !result.shoppingList) {
                this.$router.push('/pageNotFound');
            }
            this.loading = false;
        }
    }
};
</script>
